'use strict';

exports.__esModule = true;
exports.sourceType = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
//import openGraph from 'open-graph'


exports.isValidVideoURL = isValidVideoURL;
exports.infoForVideoWithURL = infoForVideoWithURL;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _verbalExpressions = require('verbal-expressions');

var _verbalExpressions2 = _interopRequireDefault(_verbalExpressions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sourceType = exports.sourceType = 'vimeo';

var digitRE = (0, _verbalExpressions2.default)().range('0', '9').stopAtFirst(true);

var nameComponentRE = (0, _verbalExpressions2.default)().anythingBut(digitRE).anythingBut('/').then('/').stopAtFirst(true);

var vimeoURLRegEx = (0, _verbalExpressions2.default)().startOfLine().maybe('http').maybe('s').maybe(':').maybe('//').maybe('www.').then('vimeo.com/').maybe('ondemand/').maybe(nameComponentRE).maybe(nameComponentRE).multiple(digitRE).maybe('/').endOfLine().withAnyCase().stopAtFirst(true); // Remove stateful g flag: http://stackoverflow.com/questions/1520800/why-regexp-with-global-flag-in-javascript-give-wrong-results


function videoIDForURL(videoURL) {
	var matches = videoURL.match(vimeoURLRegEx);
	if (matches.length === 1) {
		return matches[0];
	} else {
		return null;
	}
}

function isValidVideoURL(videoURL) {
	return vimeoURLRegEx.test(videoURL);
}

function videoInfosInVimeoInfoList(videoInfoList, videoInfoOptions) {
	return Promise.all(videoInfoList.forEach(function (videoInfo) {
		return videoInfoForAPIInfo(videoInfo[0], videoInfoOptions);
	}));
}

function videoInfoForAPIInfo(videoInfoFromAPI, _ref) {
	var embedding = _ref.embedding;
	var _ref$includeDimension = _ref.includeDimensions;
	var includeDimensions = _ref$includeDimension === undefined ? false : _ref$includeDimension;
	var _ref$includeDescripti = _ref.includeDescription;
	var includeDescription = _ref$includeDescripti === undefined ? true : _ref$includeDescripti;
	var _ref$includeThumbnail = _ref.includeThumbnail;
	var includeThumbnail = _ref$includeThumbnail === undefined ? true : _ref$includeThumbnail;

	// /video or /oembed API
	var videoID = videoInfoFromAPI['id'] || videoInfoFromAPI['video_id'];

	// /oembed API doesn't provide a URL
	var url = videoInfoFromAPI['url'] || 'https://www.vimeo.com/' + videoID;

	var title = videoInfoFromAPI['title'];

	var publishedDate = videoInfoFromAPI['upload_date'];
	var updatedDate = null;

	var description = videoInfoFromAPI['description'];

	// Differences between /oembed and /video
	var thumbnailImageURL = videoInfoFromAPI['thumbnail_url'] || videoInfoFromAPI['thumbnail_large'];

	var videoInfo = {
		sourceType: sourceType,
		videoID: videoID,
		url: url,
		title: title,
		publishedDate: publishedDate,
		updatedDate: updatedDate,
		description: description,
		thumbnailImageURL: thumbnailImageURL
	};

	var oEmbedPromise = null;

	if (includeDimensions || embedding) {
		var width = videoInfoFromAPI.width;
		var height = videoInfoFromAPI.height;


		videoInfo.originalDimensions = {
			width: width,
			height: height
		};

		// TODO: Extend to work with multiple sizes (e.g. Desktop, Mobile, etc)
		if (embedding) {
			var _ret = function () {
				var embeddedWidth = embedding.width;
				var embeddedHeight = void 0;
				if (!!embedding.aspectRatio) {
					embeddedHeight = Math.round(embeddedWidth / embedding.aspectRatio);
				} else {
					var scaleFactor = embeddedWidth / width;
					embeddedHeight = Math.round(height * scaleFactor);
				}

				/*
    embedCode = "<iframe width=\"#{embeddedWidth}\" height=\"#{embeddedHeight}\" src=\"http://www.youtube.com/embed/#{videoID}?wmode=opaque&feature=oembed&showinfo=0&theme=light\" frameborder=\"0\" allowfullscreen></iframe>"
    */

				return {
					v: promiseVimeoOEmbed({
						url: url,
						maxwidth: embeddedWidth,
						width: embeddedWidth,
						maxheight: embeddedHeight,
						byline: false,
						title: false
					}).then(function (oembedInfo) {
						videoInfo.desktopSize = {
							embedCode: oembedInfo['html'],
							dimensions: {
								width: oembedInfo['width'] || embeddedWidth,
								height: oembedInfo['height'] || embeddedHeight
							}
						};

						// /oembed has a larger thumbnail for some reason.
						videoInfo.thumbnailImageURL = oembedInfo['thumbnail_url'];

						return videoInfo;
					})
				};
			}();

			if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		}
	}

	return Promise.resolve(videoInfo);
}

function promiseVimeoOEmbed() {
	var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

	var url = 'https://vimeo.com/api/oembed.json?' + _querystring2.default.stringify(options);
	return _axios2.default.get(url).then(function (_ref2) {
		var data = _ref2.data;
		return data;
	});
}

function infoForVideoWithURL(videoURL) {
	var videoInfoOptions = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	return promiseVimeoOEmbed({ url: videoURL }).then(function (oembedData) {
		return _axios2.default.get('https://vimeo.com/api/v2/video/' + oembedData.video_id + '.json').then(function (_ref3) {
			var data = _ref3.data;
			return videoInfoForAPIInfo(data[0], videoInfoOptions);
		}).catch(function (error) {
			console.log('Vimeo /video API error', error);
			return videoInfoForAPIInfo(oembedData, videoInfoOptions);
		});
	});
}


//////////////////
// WEBPACK FOOTER
// ./~/silverscreen/lib/vimeo.js
// module id = 694
// module chunks = 0